import type { ISetting } from "@bbj-types/setting";
import { buildAxiosInstance } from "@root/api/api.tools";
import { useSuspense } from "@root/api/tools/axios";

const axios = buildAxiosInstance(`${import.meta.env.VITE_SETTING_SERVICE_URL}/v2/settings`);

export enum DomainType {
  SETTINGS = "settings",
}
export enum SettingType {
  WORKSHOPS = "workshops",
}

export type TGetSettingsQuery = {
  domain: DomainType;
  settingType: SettingType;
};
export type TGetSettingsResponse = Record<string, Pick<ISetting, "values">>;

export const useSupenseGetUserOrganisationsSettings = (params: TGetSettingsQuery) => {
  return useSuspense(
    () =>
      axios.get<TGetSettingsResponse>("/userOrganisations", {
        withCredentials: true,
        params,
      }),
    [params]
  );
};
